import React from 'react';
import { connect } from 'react-redux';

import {
  ReduxStateType,
  HardwareOptionType,
  CmsPageContentType,
  CmsPageContentIdentifier,
} from '@/types/fitting-hardware';

import { getCmsContent, getHardwareOptions, getHardwareSelectionHint } from '@/redux/fitting-hardware';

import ItemPanel from '@/components/fitting-hardware/HardwareSelector/Item/ItemPanel';
import Item from './Item';

export interface HardwareSelectorProps {
  onHardwareOptionSelected: (index: number, hardwareOption: HardwareOptionType) => void
  onBuyHardwareTeaserClick: VoidFunction
  isFmsTariff: boolean
}

export interface StateProps {
  hardwareOptions: HardwareOptionType[]
  cmsContent: CmsPageContentType
  hardwareSelectionHint: string
}

const HardwareSelector = ({
  hardwareOptions,
  cmsContent,
  hardwareSelectionHint,
  onHardwareOptionSelected,
  onBuyHardwareTeaserClick,
  isFmsTariff,
}: StateProps & HardwareSelectorProps) => (
  <div className="shop-tile-col" style={{ marginLeft: '0'}}>
    {hardwareOptions && (
      <div className="shop-tile-tariff-slider" style={{ paddingBottom: 0 }}>
        <div className="shop-tile-tariff-slider-scroll-area">
          {hardwareOptions.map((option, index) => (
            <Item
              key={option.articleId}
              checked={option.selected}
              hardwareOption={option}
              activationFeeText={cmsContent[CmsPageContentIdentifier.ActivationFeeText]}
              onClick={() => onHardwareOptionSelected(index, option)}
            />
          ))}
          { isFmsTariff && (
            <ItemPanel onClick={onBuyHardwareTeaserClick}>
              <a
                dangerouslySetInnerHTML={
                  { __html: cmsContent[CmsPageContentIdentifier.BuyHardwareTeaser] }
                }
              />
            </ItemPanel>
          )}
        </div>
      </div>
    )}
    <div
      dangerouslySetInnerHTML={{ __html: hardwareSelectionHint }}
    />
  </div>
);

const mapStateToProps = (state: ReduxStateType): StateProps => ({
  hardwareOptions: getHardwareOptions(state),
  cmsContent: getCmsContent(state),
  hardwareSelectionHint: getHardwareSelectionHint(state),
});

export default connect(mapStateToProps)(HardwareSelector);
